var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(-190 -3915)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(190 3915)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_driver",
    d: "M14.985,2a5.327,5.327,0,1,0,5.327,5.327A5.347,5.347,0,0,0,14.985,2Zm0,2.663a2.663,2.663,0,1,1-2.663,2.663A2.643,2.643,0,0,1,14.985,4.663Zm0,10.654A17.914,17.914,0,0,0,7.06,17.1C4.834,18.227,3,19.931,3,22.241v3.439l4.234,1.059A7.914,7.914,0,0,0,7,28.634H9.659a5.327,5.327,0,0,1,10.654,0h2.663a7.915,7.915,0,0,0-.239-1.9l4.234-1.059V22.241c0-2.309-1.834-4.014-4.06-5.142A17.914,17.914,0,0,0,14.985,15.317Zm0,2.663a15.593,15.593,0,0,1,6.724,1.5c1.769.9,2.6,1.987,2.6,2.765V23.6l-2.648.661a7.968,7.968,0,0,0-13.348,0L5.663,23.6V22.241c0-.777.829-1.868,2.6-2.765A15.593,15.593,0,0,1,14.985,17.98Z",
    transform: "translate(205 3930)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon25);
export default __webpack_public_path__ + "static/media/facilityIcon25.2a03d17d43f35345a48b0e6a7a79f2e8.svg";
export { ForwardRef as ReactComponent };